export const generateCode = (name: string, existingCodes: string[] = []): string => {
  if (!name) return '';

  const cleanName = name.replace(/[^a-zA-Z0-9 ]/g, '').toUpperCase();
  const words = cleanName.split(/\s+/).filter(w => w.length > 0);
  
  if (words.length === 0) return '';

  let candidate = '';

  // Step 1: Generate preferred candidate based on word count
  if (words.length >= 3) {
    // Take 1st char of first 3 words
    candidate = words.slice(0, 3).map(w => w[0]).join('');
  } else if (words.length === 2) {
    // 1st char of W1, 2nd char of W1, 1st char of W2
    // Example: KALITA CAFFEE -> K (from KALITA) + A (from KALITA) + C (from CAFFEE)
    const w1 = words[0];
    const w2 = words[1];
    candidate = (w1[0] || '') + (w1[1] || '') + (w2[0] || '');
  } else {
    // 1 Word: Take first 3 chars
    candidate = words[0].slice(0, 3);
  }

  // Ensure candidate is exactly 3 chars (pad with X if needed? Or just return short?)
  // Requirement says "exactly or up to 3". Usually 3 is preferred.
  // If candidate < 3, we can't do much else than return it.
  
  if (!existingCodes.includes(candidate)) {
    return candidate;
  }

  // Step 2: Conflict Resolution - Generate alternatives via subsequences
  // We need to generate all subsequences of length 3 from the cleanName (without spaces)
  const flatName = cleanName.replace(/\s+/g, '');
  
  // We want to prioritize "earlier" characters.
  // A simple way is to iterate through all combinations of indices (i, j, k) where i < j < k
  
  for (let i = 0; i < flatName.length; i++) {
    for (let j = i + 1; j < flatName.length; j++) {
      for (let k = j + 1; k < flatName.length; k++) {
        const alt = flatName[i] + flatName[j] + flatName[k];
        if (!existingCodes.includes(alt)) {
          return alt;
        }
      }
    }
  }

  // If all subsequences are taken, return original (user will have to manually fix) or maybe append numbers?
  // The prompt says "try to make most similar name by taking other characters".
  // If we fail, we just return the original colliding one and let validation handle it?
  // Or return empty?
  // Let's return the original candidate if we can't find a better one, the form will show error if validation checks uniqueness (which it currently doesn't strictly, but we should aim to provide a unique one).
  
  return candidate;
};
